import { IPaginationReturn } from '../../interfaces/IPaginationReturn';
import { useRequest } from '../providers/useRequest';
import AppError from '../../errors/AppError';
import IWorkShift from '../../interfaces/IWorkShift';

export interface IFilterWorkShift {
  id?: number | null;
}

const useWorkShiftService = () => {
  const request = useRequest<IWorkShift>();
  const path = 'employee/workshift';

  const list = async (
    perPage: number,
    currentPage: number,
    orderField: string,
    direction: 'asc' | 'desc',
    filter?: IFilterWorkShift,
  ): Promise<IPaginationReturn<IWorkShift[]>> => {
    return await request
      .postAndGetManyPaginated({
        path: `${path}/list?perPage=${perPage}&currentPage=${currentPage}&orderBy=${orderField}&orderDirection=${direction}`,
        sendAuthorization: true,
        body: { ...filter },
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const findById = async (id: number): Promise<IWorkShift> => {
    return await request
      .getOne({
        path: `${path}/${id}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listWorkShiftByDescription = async (description: string): Promise<IWorkShift[]> => {
    return await request
      .getMany({
        path: `${path}/findByDescription/${description}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listWorkShiftSearch = async (filter: string): Promise<IWorkShift[]> => {
    if (filter === '') {
      filter = ' ';
    }

    const url = filter
      ? `${path}/search?perPage=300&currentPage=1&orderBy=code&orderDirection=asc&filter=${filter}`
      : `${path}/search?perPage=300&currentPage=1&orderBy=code&orderDirection=asc&filter= `;

    return await request
      .getManyPaginated({
        path: url,
        sendAuthorization: true,
      })
      .then(result => {
        return result?.data;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const listWorkShiftByrequestId = async (id: number): Promise<IWorkShift[]> => {
    return await request
      .getMany({
        path: `${path}/ListByrequestId/${id}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const create = async ({ code, description }: IWorkShift): Promise<IWorkShift> => {
    return await request
      .post({
        path: `${path}`,
        sendAuthorization: true,
        body: { code, description },
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const update = async (id: number, { code, description }: IWorkShift): Promise<IWorkShift> => {
    return await request
      .put({
        path: `${path}/${id}`,
        sendAuthorization: true,
        body: { code, description },
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  const remove = async (id: number): Promise<void> => {
    return await request
      .remove({
        path: `${path}/${id}`,
        sendAuthorization: true,
      })
      .then(result => {
        return result;
      })
      .catch(error => {
        throw new AppError(error.message);
      });
  };

  return {
    list,
    listWorkShiftByDescription,
    findById,
    listWorkShiftSearch,
    listWorkShiftByrequestId,
    create,
    update,
    remove,
  };
};

export { useWorkShiftService };
